<app-page-header
  title="Home"
  active_item="Licenciamentos"
  titleLink="/licensing"
></app-page-header>

<div class="loading-wallet" *ngIf="!isLoaded">
  <div class="dimmer active">
    <div class="lds-ring"><div></div></div>
  </div>
</div>

<h5>Licenciamentos</h5>

<div class="row">
  <div class="col-12">
    <div class="card rounded-10 shadow" *ngIf="!isInsert">
      <div class="card-header d-flex justify-content-between align-items-center">
        <div class="card-title mb-0">Lista de Licenciamentos</div>
        <button
          type="button"
          class="our-button btn btn-pill btn-primary float-end"
          (click)="openInsert()"
        >
          <i class="fe fe-plus"></i> Licenciamento
        </button>
      </div>
      <div class="card-body">
        <div class="scrollable-layout">
          <div class="table-responsive our-table">
            <table class="table table-striped text-nowrap mb-0">
              <thead class="border-top">
                <tr>
                  <th scope="col" class="text-capitalize">Id de Registro</th>
                  <th scope="col" class="text-capitalize">Descrição</th>
                  <th scope="col" class="text-capitalize">Expiração</th>
                  <th scope="col" class="text-capitalize">Cnpj</th>
                  <th scope="col" class="text-capitalize">Razão social</th>
                  <th scope="col" class="text-capitalize text-center">Ações</th>
                  <th scope="col" class="text-capitalize align-middle text-center">Status</th>
                </tr>
              </thead>
              <tbody>
                <tr class="border-bottom" *ngFor="let row of licensings">
                  <td><span>{{ row.id }}</span></td>
                  <td><span>{{ row.description }}</span></td>
                  <td>
                    <span>{{
                      isValidDate(row.expiresAt)
                        ? (row.expiresAt | date : "dd/MM/yyyy")
                        : "-"
                    }}</span>
                  </td>
                  <td><span>{{ row.cnpj | mask: "CPF_CNPJ" }}</span></td>
                  <td><span>{{ row.razaoSocial }}</span></td>
                  <td class="align-middle text-center">
                    <button
                      type="button"
                      class="btn-blue-dp"
                      title="Editar"
                      (click)="openEdit(editModal, row)"
                    >
                      <i class="fe fe-edit"></i>
                    </button>
                  </td>
                  <td class="align-middle text-center">
                    <label class="custom-switch status-toggle-readonly">
                      <input
                        type="checkbox"
                        class="custom-switch-input"
                        [checked]="row.active"
                        disabled
                      />
                      <span class="custom-switch-indicator"></span>
                    </label>
                  </td>
                </tr>
                <tr *ngIf="isLoaded && licensings.length === 0">
                  <td colspan="7">{{ "common.noData" | translate }}</td>
                </tr>
              </tbody>
            </table>
            <div class="d-flex justify-content-between p-2">
              <ngb-pagination
                [collectionSize]="total"
                [maxSize]="5"
                [rotate]="true"
                [(page)]="page"
                [pageSize]="pageSize"
                (pageChange)="pageChange()"
              ></ngb-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card rounded-10 shadow" *ngIf="isInsert">
      <div class="card-header">
        <div class="card-title mb-0">Adicionar Licenciamento</div>
      </div>
      <div class="card-body">
        <form [formGroup]="form">
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  {{ "common.description" | translate }}
                  <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  formControlName="description"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      form.controls.description.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  Modalidade <span class="text-danger">*</span>
                </label>
                <select
                  class="form-select"
                  formControlName="product"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      form.controls.product.invalid && isSubmitted
                  }"
                >
                  <option value="">Selecione</option>
                  <option *ngFor="let p of productOptions" [value]="p.id">
                    {{ p.name }}
                  </option>
                </select>
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  CNPJ <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  formControlName="cnpj"
                  mask="00.000.000/0000-00"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      form.controls.cnpj.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
            <div class="col-xl col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  Razão Social <span class="text-danger">*</span>
                </label>
                <input
                  class="form-control"
                  type="text"
                  formControlName="razaoSocial"
                  [ngClass]="{
                    'is-invalid state-invalid':
                      form.controls.razaoSocial.invalid && isSubmitted
                  }"
                />
                <div class="invalid-feedback">
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-xl-3 col-lg-6 col-sm-6">
              <div class="form-group">
                <label class="form-label">
                  Expiração <span class="text-danger">*</span>
                </label>
                <mat-form-field
                  appearance="fill"
                  class="w-100 date-align custom-datetime"
                >
                  <input
                    matInput
                    [matDatepicker]="pickerCreate"
                    placeholder="DD/MM/YYYY"
                    formControlName="expiresAt"
                  />
                  <mat-datepicker-toggle
                    matSuffix
                    [for]="pickerCreate"
                  ></mat-datepicker-toggle>
                  <mat-datepicker #pickerCreate startView="month"></mat-datepicker>
                </mat-form-field>
                <div
                  class="invalid-feedback d-block"
                  *ngIf="form.controls.expiresAt.invalid && isSubmitted"
                >
                  {{ "common.fieldRequired" | translate }}
                </div>
              </div>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-pill btn-primary float-start"
            (click)="return()"
          >
            <i class="fe fe-arrow-left"></i> {{ "common.back" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-pill btn-primary float-end"
            (click)="add()"
          >
            <i class="fe fe-plus"></i> {{ "common.add" | translate }}
          </button>
        </form>
      </div>
    </div>
  </div>
</div>

<ng-template #editModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Editar Licenciamento</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="modal.dismiss()"
    ></button>
  </div>
  <div class="modal-body">
    <div class="mb-3">
      <div class="row g-3">
        <div class="col-md-6">
          <label class="form-label">ID do Licenciamento</label>
          <input
            type="text"
            class="form-control"
            [value]="selected?.id || '-'"
            readonly
          />
        </div>

        <div class="col-md-6">
          <label class="form-label">Description</label>
          <input
            type="text"
            class="form-control"
            [value]="selected?.description || '-'"
            readonly
          />
        </div>
      </div>
    </div>

    <form [formGroup]="editForm">
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label class="form-label">
              {{ "common.description" | translate }}
              <span class="text-danger">*</span>
            </label>
            <input
              class="form-control"
              type="text"
              formControlName="description"
              [ngClass]="{
                'is-invalid state-invalid':
                  editForm.controls.description.invalid && isEditSubmitted
              }"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label class="form-label">
              Expiração <span class="text-danger">*</span>
            </label>
            <mat-form-field
              appearance="fill"
              class="w-100 date-align custom-datetime"
            >
              <input
                matInput
                [matDatepicker]="pickerEdit"
                placeholder="DD/MM/YYYY"
                formControlName="expiresAt"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="pickerEdit"
              ></mat-datepicker-toggle>
              <mat-datepicker #pickerEdit startView="month"></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div class="col-md-6 d-flex align-items-center">
          <label class="custom-switch mt-4">
            <input
              type="checkbox"
              class="custom-switch-input"
              formControlName="active"
            />
            <span class="custom-switch-indicator"></span>
            <span class="custom-switch-description">Ativo</span>
          </label>
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button
      type="button"
      class="btn btn-primary btn-pill"
      (click)="saveEdit()"
    >
      Salvar
    </button>
  </div>
</ng-template>

<ng-template #passwordModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">Confirme sua senha</h5>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="cancelPassword()"
    ></button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <p *ngIf="passwordError" class="text-danger mb-2">{{ passwordError }}</p>
      <input
        type="password"
        class="form-control"
        placeholder="Senha"
        [(ngModel)]="passwordValue"
        (keyup.enter)="confirmPassword()"
      />
    </div>
  </div>
  <div class="modal-footer text-center">
    <button
      type="button"
      class="btn btn-lg btn-primary btn-pill mx-auto d-block"
      (click)="confirmPassword()"
      [disabled]="passwordSubmitting"
    >
      CONFIRMAR
    </button>
  </div>
</ng-template>
